var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudibackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 432,
    viewBox: "0 0 1440 432",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: -49.7161,
    y: -135,
    width: 638.002,
    height: 584.472,
    rx: 50,
    transform: "rotate(45 -49.7161 -135)",
    fill: "#E6DEFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -183.716,
    y: -130,
    width: 638.002,
    height: 584.472,
    rx: 50,
    transform: "rotate(45 -183.716 -130)",
    fill: "#E6DEFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 1455.36,
    y: -184.929,
    width: 125.311,
    height: 584.472,
    rx: 50,
    transform: "rotate(45 1455.36 -184.929)",
    fill: "#E6DEFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 1678.28,
    y: -181,
    width: 137.698,
    height: 584.472,
    rx: 50,
    transform: "rotate(45 1678.28 -181)",
    fill: "#E6DEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudibackground);
export default __webpack_public_path__ + "static/media/audibackground.136b5377259b1546be142aed94ce2047.svg";
export { ForwardRef as ReactComponent };